import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import  InternetStatus  from '../components/InternetStatus';

const MainLayout = ({ children, session }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isAuthChecked, setIsAuthChecked] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token && location.pathname !== '/login') {
      navigate('/login');
    } else {
      setIsAuthChecked(true);
    }
  }, [navigate, location]);

  if (!isAuthChecked && location.pathname !== '/login') {
    return null; // Optionally show a loader
  }

  return (

      <div className="app-container">
        <Sidebar session={session} />
        <div className="main-panel">
          <Header session={session} />
          <div className="content">
            <InternetStatus/>
            {children}
            <footer className="footer">
              <img className="flag_image" src="/assest/logo/flag.png" alt="Logo" />
              <span>Proudly Made in India</span>
              <img className="flag_image" src="/assest/logo/flag.png" alt="Logo" />
            </footer>
          </div>
        </div>
      </div>

  );
};

export default MainLayout;
  